export const formatNumber = (value: number | null | undefined, decimals = 2): string =>
  value === null || value === undefined
    ? 'N/A'
    : Number(value).toLocaleString('en-US', {
        minimumFractionDigits: decimals,
        maximumFractionDigits: decimals,
      });

// Volume formatting lives in the shared library so the API (PDF) and Admin UI
// stay in sync. Re-exported here to keep the existing import path stable.
export { formatVolume } from '@ministry-of-wine/shared';

// Long date formatting (e.g. "17th August 2025") lives in the shared library
// so the API (PDF) and Admin UI stay in sync. Re-exported here for a stable path.
export { formatLongDate } from '@ministry-of-wine/shared';

/**
 * Format role codes to display names
 */
export const formatRole = (role: string): string => {
  const roleMap: Record<string, string> = {
    'superadmin': 'Super Admin',
    'supplier_admin': 'Supplier Admin',
    'supplier_user': 'Supplier User',
  };

  return roleMap[role] || role;
};
